import { render, staticRenderFns } from "./withdraw-info.vue?vue&type=template&id=81a2ec96&scoped=true&"
import script from "./withdraw-info.vue?vue&type=script&lang=js&"
export * from "./withdraw-info.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-info.vue?vue&type=style&index=0&id=81a2ec96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a2ec96",
  null
  
)

export default component.exports